import type { DigestedSchema } from '@wix/wix-data-client-common-standalone'
import { isFieldAllowedInRoutingUrl } from './isFieldAllowedInRoutingUrl'
import type { ExtendedFieldSpec } from '../fields/fieldQueries'

export const getFieldKeyForUrl = ({
  collectionFields,
  displayField,
  isTPACollection,
}: {
  collectionFields: ExtendedFieldSpec[]
  displayField?: string
  isTPACollection: boolean
}): string | undefined => {
  // TODO the partial schema here is not passing all of the properties required by isFieldAllowedInRoutingUrl
  // The signature of getFieldKeyForUrl must be changed to all necessary schema properties that
  //isFieldAllowedInRoutingUrl is using
  const schema = { fields: collectionFields, isTPACollection }
  if (isFieldAllowedInRoutingUrl(schema as DigestedSchema, displayField)) {
    return displayField
  }
  const field = collectionFields.find(
    ({ name, isDeleted }) =>
      !isDeleted && isFieldAllowedInRoutingUrl(schema as DigestedSchema, name),
  )

  return field && field.name
}
